import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const TypographyStyled = styled(Typography)`
  text-align: center;
  margin-bottom: 2rem;
`;

export const ColumnPickerStyled = styled.div`
  margin: 1.5rem 0;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-left: 1rem;
    }
    ${theme.devices.smallDesktop} {
      margin: 0;
      padding: 0 1.875rem;
    }
  `}
`;

export const ShowHideColumnToggleWrapStyled = styled(FlexContainer)`
  margin-right: 0.375rem;
`;
export const ResetButtonStyled = styled(Button)`
  display: block;
  margin: 1rem 0 1rem auto;
`;
